import { Paper } from '@mui/material';
import styled from 'styled-components';

export const Item = styled(Paper)`
  padding: 7px 23px;
  color: ${({ theme: { palette } }) => palette.grey[200]};
  font-weight: 700;
  background: ${({ theme: { palette } }) => palette.grey[100]};
  font-size: 0.75rem;
`;
